import React from "react";
import { ArrowDown } from "lucide-react";
import {
  formatPromotionBadge,
  getPackageAdminBadgeLabel,
  isPackagePromo,
  promoShowsCaptionBadge,
} from "../sales/promotionUtils";

const PACKAGE_BUY_LABEL = "לרכישה במארז";

/**
 * Sale caption shown beside the card price for quantity/pack/threshold promos.
 * Plain FLAT/PERCENT sales stay caption-free (strike + sale price only).
 * Package: customer gets "לרכישה במארז ↓"; manager gets "מחיר מארז".
 * Dual package-unit sale tag appears only in the price-compare popup.
 */
const PromoBadge = ({ promotion, onPackageBuy }) => {
  if (!promoShowsCaptionBadge(promotion)) return null;

  const badge = formatPromotionBadge(promotion);
  if (!badge) return null;

  const isPackage = isPackagePromo(promotion);

  if (isPackage && onPackageBuy) {
    return (
      <button
        type="button"
        className="sales-jump tag tag--sale tag--action tag--inline tag--package-buy"
        aria-label={PACKAGE_BUY_LABEL}
        onClick={(e) => {
          e.stopPropagation();
          onPackageBuy();
        }}
      >
        <span className="tag__label">{PACKAGE_BUY_LABEL}</span>
        <ArrowDown aria-hidden size={14} strokeWidth={2.5} />
      </button>
    );
  }

  if (isPackage) {
    return (
      <span className="sales-jump tag tag--sale tag--inline">
        <span className="tag__label">
          {getPackageAdminBadgeLabel(promotion)}
        </span>
      </span>
    );
  }

  return (
    <span className="sales-jump tag tag--sale tag--inline">
      <span className="tag__label">{badge.text}</span>
    </span>
  );
};

export default React.memo(PromoBadge);
